import {
	DeploymentGroup,
	UserGroupLight
} from 'phoenix/domain';

export interface PhoenixUserLink {
	DocumentLocksUri: string;
	Lock: string;
	Self: string;
	StatisticsUri: string;
	Unlock: string;	
}

export interface PhoenixUser {
	DateCreated: string;
	EmailAddress: string;
	IsExternal: boolean;
	IsLocked: boolean;
	Links: PhoenixUserLink;
	Password: string;
	PasswordExpired: boolean;
	UserId: number;
	UserLibrarySize: number;
	UserName: string;
	Type: string;
	LastLogin:string;
	Embedded: {
		AdministratorOfDeploymentGroups:DeploymentGroup[]
		Roles:string[],
		Deployment: {
			DeploymentId:number;
			Name:string;
			Embedded: {
				DeploymentGroup: DeploymentGroup
			}
		},
		UserGroups:UserGroupLight[]
	}
}

export interface CurrentUser {
	DeploymentId:number;
	DeploymentGroupId;
	Embedded: {
		User:PhoenixUser;
		Roles:string[];
		Privileges:string[];
	},
	IsSysAdmin:boolean;
	PasswordExpired:boolean;
	UserId:number;
	UserName:string;
	SystemName:string;
	Token:string;
	IsExpired:boolean;
}

export interface TypeAheadUsers {
	Links:{
		Self:string;
	};
	Users:PhoenixUser[];
}

export interface PendingUser {
	EmailAddress:string;
	ExpirationDate:string | Date;
	IssueDate:string | Date;
	Links: {
		ResendInviteUri:string;
		SendInviteToNewEmailUri:string;
	}
}

export interface SearchUser {
	UserName: string;
	UserId: number;
}

export interface UserStatistic {
	UserId:number;	
	Count:number;
	Label:string;
	Id:string;
}

export enum UserStatType {
	DocumentsStoredByUser = 'DocumentsStoredByUser',
	TotalDiskUsage = 'TotalDiskUsage'
}

export const isPhoenixUser = (obj: any): obj is PhoenixUser => {
	return obj && angular.isDefined(obj.UserId) 
			   && angular.isDefined(obj.EmailAddress);
}


export const isCurrentUser = (obj:any):obj is CurrentUser => {
	return obj && angular.isDefined(obj.UserId) 
			   && angular.isDefined(obj.IsExpired)  
			   && angular.isDefined(obj.IsSysAdmin)
			   && angular.isDefined(obj.Token);
} 


// WEBPACK FOOTER //
// ./src/phoenix/domain/user.ts